<template>
  <div class="row">
    <div class="col-md-12 card mt-3">
      <div class="card-header">
        <div class="category">Liste utilisateurs</div>
        <div class="text-right mb-3">
          <p-button @click="goToAdd()" class="mt-3" type="primary">Ajouter Utilisateur</p-button>
        </div>
      </div>
      <div class="card-body row">
        <div class="col-sm-6">
          <el-select
            class="select-default"
            v-model="pagination.perPage"
            placeholder="Per page">
            <el-option
              class="select-default"
              v-for="item in pagination.perPageOptions"
              :key="item"
              :label="item"
              :value="item">
            </el-option>
          </el-select>
        </div>
        <div class="col-sm-6">
          <div class="pull-right">
            <fg-input class="input-sm"
                      placeholder="Recherche"
                      v-model="query"
                      addon-right-icon="nc-icon nc-zoom-split">
            </fg-input>
          </div>
        </div>
        <div class="col-sm-12 mt-2">
          <el-table class="table-striped" :data="table" border @sort-change="sortChange">
             <div slot="empty" v-if="loading">
              <img src="/img/loading.gif" style="height: 100px; width: 100px" />
            </div>
            <el-table-column label="Photo">
                <template v-slot="{ row }">
                    <img v-if="row.profile_image" :src="base_media+row.profile_image || '/img/default.png'" class="avatar rounded-circle"/>
                </template>
            </el-table-column>
            <el-table-column label="Nom" prop="name" sortable="custom" />
            <el-table-column label="No Int" prop="no_int" sortable="custom" />
            <el-table-column label="No Ext" prop="no_ext" sortable="custom" />
            <el-table-column label="Mobile" prop="mobile" sortable="custom" />
            <el-table-column label="Email" prop="email" sortable="custom" />
            <el-table-column
              label="Status"
              prop="roles.name"
              sortable="custom"
            >
              <template v-slot="{ row }">
                <span v-if="row.roles.length >0">{{(row.roles[0].name == 'member')?'membre': row.roles[0].name}}</span>
              </template>
            </el-table-column>
<!--            <el-table-column-->
<!--              label="Créer le"-->
<!--              prop="created_at"-->
<!--              sortable="custom"-->
<!--            />-->
            <el-table-column
              fixed="right"
              class-name="td-actions"
              label="Actions">
              <template slot-scope="props">
                <p-button type="success" size="sm" icon @click="goToEdit(props.row.id)">
                  <i class="fa fa-edit"></i>
                </p-button>
                <p-button type="danger" size="sm" icon @click="destroy(props.row.id)">
                  <i class="fa fa-times"></i>
                </p-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="col-sm-6 pagination-info">
          <p class="category"> {{from + 1}} / {{to}} sur {{total}} utilisateurs</p>
        </div>
        <div class="col-sm-6">
          <p-pagination class="pull-right"
                        v-model="pagination.currentPage"
                        :per-page="pagination.perPage"
                        :total="total">
          </p-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import _ from 'lodash';
  import { Table, TableColumn, Select, Option } from 'element-ui';
  import PPagination from 'src/components/UIComponents/Pagination.vue'
  import swal from "sweetalert2";
  const media = process.env.VUE_APP_MEDIA_BASE_URL;

  export default {
    components: {
      PPagination,
      [Select.name]: Select,
      [Option.name]: Option,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn
    },

    data: () => ({
      loading: true,
      table: [],
      footerTable: ["Name", "Created At", "Actions"],
      base_media: media,
      query: null,

      sort: "created_at",

      pagination: {
        perPage: 100,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50,99,100,1000],
      },

      total: 0

    }),

    computed: {
      from() {
        return this.pagination.perPage * (this.pagination.currentPage - 1);
      },

      to() {
        let highBound = this.from + this.pagination.perPage;
        if (this.total < highBound) {
          highBound = this.total;
        }
        return highBound;
      },
    },

    watch: {
      query: {
        handler: 'getListDebounced',
        immediate: true
      },
      pagination: {
        handler: 'getList',
        immediate: false,
        deep: true
      },
    },

    methods: {
      getListDebounced: _.debounce(function () {
        this.getList()
      }, 300),

      async getList() {
        let params = {
          include: "roles",
          ...(this.sort ? {sort: this.sort} : {}),
          filter: {
            ...(this.query ? {name: this.query} : {}),
            ...(this.query ? {email: this.query} : {}),
            ...(this.query ? {roles: this.query} : {}),
            ...(this.query ? {no_int: this.query} : {}),
            ...(this.query ? {no_ext: this.query} : {}),
            ...(this.query ? {mobile: this.query} : {}),
          },
          page: {
            number: this.pagination.currentPage,
            size: this.pagination.perPage
          }
        }

        try {
          await this.$store.dispatch("users/list", params)
          this.table = this.$store.getters["users/list"]
          this.total = this.$store.getters["users/listTotal"]
          this.loading = false
        } catch (e) {
          this.$notify({
            type: 'danger',
            message: "Oups, quelque chose s'est mal passé !",
            icon: 'nc-icon nc-bell-55',
          })
        }
      },

      async destroy(id) {
        if (this.$isDemo == 1 && ["1", "2", "3"].includes(id)) {
        this.$notify({
          type: "danger",
          message: "You are not allowed to change data of default users.",
          icon: 'nc-icon nc-bell-55',
        });
        return;
      }
      try {
        const confirmation = await swal.fire({
          title: 'Supprimer l\'utilisateur ?',
          text: `Cette action est irréversible !`,
          icon: '',
          showCancelButton: true,
          customClass: {
            confirmButton: 'btn btn-success btn-fill',
            cancelButton: 'btn btn-danger btn-fill'
          },
          confirmButtonText: 'Supprimer',
          cancelButtonText: 'Annuler',
          buttonsStyling: false
        })

        if (confirmation.value === true) {
          await this.$store.dispatch("users/destroy", id)
          this.$notify({
            type: 'success',
            message: 'User deleted successfully.',
            icon: 'nc-icon nc-bell-55',
          })
          await this.getList()
        }
       } catch (error) {
          if(error.response.data.errors[0]) {
            this.$notify({
              type: "danger",
              message: error.response.data.errors[0].title,
              icon: 'nc-icon nc-bell-55',
            });
          } else {
            this.$notify({
              type: "danger",
              message: "Oups, quelque chose s'est mal passé !",
              icon: 'nc-icon nc-bell-55',
            });
          }
        } 
      },

      goToAdd() {
        this.$router.push({name: 'Add User'})
      },

      goToEdit(id) {
        this.$router.push({name: 'Edit User', params: {id}})
      },

      sortChange({ prop, order }) {
        if (order === "descending") {
          this.sort = `-${prop}`;
        } else {
          this.sort = `${prop}`;
        }
        this.getList();
      },
    }
  }
</script>
